<template>
  <transition mode="out-in" appear @enter="enter" @leave="leave" :css="false">
    <section class="clip-m">

      <div class="clip-m-content">
        <ClipMobilePage v-for="(data, key) in clipLayerData"
                    :clipData="data"
                    :key="key"
                    :class="'clip-con--'+data.clipId">
        </ClipMobilePage>
      </div>
      <FrameBook></FrameBook>
      <ScrollBtn></ScrollBtn>
    </section>
  </transition>
</template>

<script>
  import BaseSection from "./mixins/BaseSection.js";
  import gsap from "gsap";
  import ClipMobilePage from '@/components/ClipMobilePage';
  import FrameBook from '@/components/FrameBook';
  import ScrollBtn from "../components/ScrollBtn";

  export default {
    name: "clip-m",
    components: {ClipMobilePage, FrameBook, ScrollBtn},
    mixins: [BaseSection],
    data(){
      return{
        name:'clip',
        currentClip:null,
        clipLayerData:[
          {
            clipId:'1',
            tit:`${this.$t("clip.1.tit")}`,
            desc:`${this.$t("clip.1.desc")}`,
            clips:[
              {
                classId:'1',
                video:'https://vod.plaync.com/LineageW/03_1_Eternally_f_0810.mp4',
                youtube:{
                  ko:'IwVPmm-RKqQ',
                  en:'EGql7OgWzzE',
                  ja:'lz7QfEu0h-s',
                  zh:'p_nTmA0o8QA',
                },
                coming:false,
              }
            ]
          },
          {
            clipId:'2',
            tit:`${this.$t("clip.2.tit")}`,
            desc:`${this.$t("clip.2.desc")}`,
            clips:[
              {
                classId:'2',
                video:'https://vod.plaync.com/LineageW/03_2_bloodtree_f_0810.mp4',
                youtube:'',
                coming:false,
                story:`${this.$t("clip.2.story")}`,
              }
            ]
          },
          {
            clipId: '3',
            tit: `${this.$t("clip.3.tit")}`,
            desc: `${this.$t("clip.3.desc")}`,
            clips: [
              {
                classId: '3-1',
                video: 'https://vod.plaync.com/LineageW/03_3_5guardians_f_0810.mp4',
                youtube:'',
                coming:false,
                story:`${this.$t("clip.3.story-1")}`,
              },
              {
                classId: '3-2',
                video: 'https://vod.plaync.com/LineageW/03_3_Enchant_Guide_f_0810.mp4',
                youtube:'',
                coming:false,
                story:`${this.$t("clip.3.story-2")}`,
              }
            ]
          },
          {
            clipId: '4',
            tit: `${this.$t("clip.4.tit")}`,
            desc: `${this.$t("clip.4.desc")}`,
            clips: [
              {
                classId: '4',
                coming:false,
                video: 'https://vod.plaync.com/LineageW/03_4_castlesiege_f_0810.mp4',
                youtube:'',
                story:`${this.$t("clip.4.story")}`
              }
            ]
          },
          {
            clipId: '5',
            tit: `${this.$t("clip.5.tit")}`,
            desc: `${this.$t("clip.5.desc")}`,
            clips: [
              {
                classId: '5',
                coming:false,
                video: 'https://vod.plaync.com/LineageW/03_5_Shortclip5_f_0810.mp4',
                youtube:{
                  ko: "4AOxIDAGGdk",
                  en: "V0XpsKAsYfU",
                  ja: "WDxcGxmRIXI",
                  zh: "l7WnTh8NYZk",
                },
              }
            ]
          }
        ]
      }
    },
    methods:{
      setMotion(){
        const startTime = (this.currentPage == 'index')?0.01: 0.5;
        this.enterMotion = new gsap.timeline({paused:true, onStart: ()=>{this.setIsMovePage(true)}});
        this.enterMotion
          .addLabel('start')
          .from(this.$el, startTime, {opacity:0, ease:'power2.easeOut'})

        this.titMotion = new gsap.timeline({paused:true});
        this.titMotion
          .addLabel('title', '+=1')
          .fromTo(this.$el.querySelector(`.scroll-btn`), 0.5,{autoAlpha:0, y:30}, {autoAlpha:1, y:0, ease:'expo.easeOut'}, 'title+=0.2')

      },
      pageMove(num){
        const clip = this.$el.querySelector('.clip-con--'+num);
        clip.style.display = 'block';
        if(this.currentClip)this.currentClip.style.zIndex = 1;
        clip.style.zIndex = 5;
        const clipMotion = new gsap.timeline({onComplete:()=>{
            this.setIsMovePage(false);
            if(this.currentClip)this.currentClip.style.display = 'none';
            this.currentClip = clip;
          }});
        clipMotion
          .fromTo(clip, 0.5,{autoAlpha:0}, {autoAlpha:1, ease:'expo.easeOut'})
          .fromTo(clip.querySelector(`.clip-con__tit`), 0.3,{autoAlpha:0}, {autoAlpha:1, ease:'expo.easeOut'})
          .fromTo(clip.querySelector(`.clip-con__desc`), 0.3,{autoAlpha:0, y:20}, {autoAlpha:0.6, y:0, ease:'expo.easeOut'}, '-=0.2')
      },
      start(){
        const startNum = this.$route.query.page ? parseInt(this.$route.query.page) : 1;
        this.pageMove(startNum);
        this.enterMotion.play();
        this.titMotion.play();

      },
      enter(el, done){
        this.setMotion();
        this.enterMotion.eventCallback("onComplete", ()=>{
          done();
        })
        if(this.currentPage == 'index')this.autoPlay = false;
        this.setCurrentPage(this.name);
        this.setEnterPage(this);

      },
      leave(el, done){
        gsap.to(this.$el, 0.5, {opacity:0, onComplete:done})
      },
    },
    mounted() {
      this.$watch('clipQuery', (val) => {
        this.pageMove(val)
      })

      if(this.autoPlay){
        this.start();
        this.setIsIntro(false);
      }

    },
  }
</script>

<style lang="scss">
  .clip-m {
    //@include bg($bg: '../assets/img/clip_guide_m.jpg');
   // background-size: 360px auto;
    .frame__cover{
      display: none;
    }

  }

  .clip-con{
    //display: none;
    opacity:0;
  }



</style>
